export default __webpack_public_path__ + "static/media/profile_pic.5179e446.png";